
<template>
  <div id="footer">
    <h4>会聚百业 展呈世界</h4>
    <ul>
      <li @click="goTo('/')">首页</li>
      <li @click="goTo('/about')">关于中设</li>
      <li
        @click="
          openPdf(
            '%E4%B8%AD%E8%AE%BE%E9%9B%86%E5%9B%A2%E5%AE%98%E7%BD%91/%E9%9B%86%E5%9B%A2%E7%94%BB%E5%86%8C.pdf'
          )
        "
      >
        集团画册
      </li>
      <li
        @click="
          openPdf(
            '%E4%B8%AD%E8%AE%BE%E9%9B%86%E5%9B%A2%E5%AE%98%E7%BD%91/%E5%B1%95%E9%99%88%E9%83%A8%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C.pdf'
          )
        "
      >
        展陈画册
      </li>
      <li @click="handelClick()">今市数字会展平台</li>
    </ul>
    <div class="copyright">Copyright 安徽中设国际会展集团有限公司</div>
  </div>
</template>

<script>
import { configMixin } from "../core/mixins/config.mixin";

export default {
  mixins: [configMixin],
  methods: {
    handelClick() {
      const link = "https://m.jinshi.online/";
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        window.location.href = link;
      } else window.open(link, "_blank");
    },
    goTo(path) {
      this.$router.push({ path });
      this.toggleShow();
    },
    // 是否安卓
    isAndroid() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      return isAndroid;
    },
    openPdf(url) {
      if (!this.isAndroid()) {
        window.open(`https://miniapp.static.zhongsheyun.com/${url}`);
        this.toggleShow();
        return;
      }
      this.$router.push({ path: "/pdf", query: { url } });
      this.toggleShow();
    },
  },
};
</script>

<style lang="scss" scoped>
#footer {
  background: #fff url("../assets/images/bg_6.png") no-repeat;
  background-size: cover;
  height: 126px;
  width: 100%;
  padding: 18px 16px;
  ul {
    padding: 15px 16px;
    padding-bottom: 3px;
    display: flex;
    flex-wrap: wrap;
    color: #0068b7;
    color: #666666;
    font-size: 14px;
    li {
      min-width: 110px;
      margin-bottom: 12px;
      position: relative;
    }
    li::before {
      width: 5px;
      height: 5px;
      background: #0068b7;
      border-radius: 100%;
      content: "";
      position: absolute;
      top: 40%;
      left: -12px;
    }
  }
  h4 {
    font-size: 18px;
    color: #333333;
  }
  .copyright {
    border-top: 1px solid #f3f3f3;
    padding-top: 9px;
    text-align: center;
  }
}
</style>